import ValidateForm from 'widgets/validateForm';

export default {
	createFilterValidator (context) {
		function initInputErrorHelper(formView, $input) {
			let val = $input.val();

			if (val === '') {
				// "this is required"
				formView.initInputError($input, 'js_help-empty');
			} else {
				// "check your day / month" or give format message
				let reasonSubClassName = context.model.dateFormatter.getReasonInvalid(val);
				formView.initInputError($input, 'js_help-' + reasonSubClassName);
			}
		}

		// form view with validations
		return new ValidateForm({
			el: '#js_filters-form',

			/* Override validateForm.validateFields because it does weird things */
			customValidate ($inputs, $selects) {
				let valid = true;
				// Spin through each input to check if the input is valid or not.
				$inputs.each((inputIndex, inputElement) => valid = this.customRule(valid));

				return valid;
			},

			/**
			 * Custom rule for validating ALL the form fields called by the
			 * ValidateForm parent class.
			 *
			 * This is only for validating the format of the date string,
			 * not for validating business logic of the date range.
			 *
			 * @param valid boolean - whether the form data is valid
			 */
			customRule (valid) {
				let $startDateInput = context.$('.js_filters-control-startDate'),
					$endDateInput = context.$('.js_filters-control-endDate'),
					startDateRequired = $startDateInput.attr('required') === 'required',
					endDateRequired = $endDateInput.attr('required') === 'required';

				// if dates are required, check them against regexes
				if (startDateRequired || endDateRequired) {
					let isValidDateString = context.model.dateFormatter.isValidDateString,
						fromTime = $startDateInput.val(),
						toTime = $endDateInput.val(),
						startOk = true,
						endOk = true;

					// test the input value, if it's required
					if (startDateRequired) {
						startOk = isValidDateString(fromTime);
					}

					if (endDateRequired) {
						endOk = isValidDateString(toTime);
					}

					if (startOk) {
						// clear error from this input
						this.removeInputError($startDateInput);
					} else {
						// show error on this input using helper function
						initInputErrorHelper(this, $startDateInput);
						valid = false;
					}

					if (endOk) {
						// clear error from this input
						this.removeInputError($endDateInput);
					} else {
						// show error on this input using helper function
						initInputErrorHelper(this, $endDateInput);
						valid = false;
					}

					/* Since the view uses a validateForm instance which is the
					 * project standard, the model does not have its own
					 * validate() methods like a typical Backbone model.
					 * Instead, we use a model attribute to manually track if
					 * the custom dates are invalid. */
					if (startOk && endOk) {
						context.model.set('customDatesAreValid', true);
					} else {
						context.model.set('customDatesAreValid', false);
					}
				}

				return valid;
			}
		});
	}
};



// WEBPACK FOOTER //
// ./view/activity/filterValidator.es6